<!-- Do not change this file. -->

<template>
  <div class="navbar navbar-dark bg-dark">
    <div class="container-fluid pe-1">
      <div class="navbar-brand d-flex w-100" role="banner">
        <img
          src="@/assets/logo-dark.svg"
          alt="Oregon State University Logo"
          height="30"
          class="d-inline-flex align-top me-3 pe-3 border-end"
        />
        <div class="title me-3 fw-bold">{{ course }}</div>
        <!-- Displayed for medium and large screens -->
        <div class="subtitle d-none d-sm-block">{{ title }}</div>
        <!-- Displayed only for small screens -->
        <div class="subtitle d-sm-none text-truncate">{{ shortTitle }}</div>

        <div class="ms-auto" v-if="isOnActivityView">
          <button
            class="btn btn-light mx-2 d-md-none"
            @click="toggleSidebar"
            data-bs-toggle="tooltip"
            data-bs-placement="left"
            title="Toggle Sidebar"
          >
            <i class="bi bi-arrow-left-right"></i>
            <!-- no room in header for btn text when this button is visible -->
          </button>
          <button
            class="btn btn-light btn-outline"
            @click="toggleDataTable"
            data-bs-toggle="tooltip"
            data-bs-placement="left"
            title="View Data Table"
          >
            <i class="bi bi-table"></i>
            <span class="d-none d-sm-inline ms-1">Data Table</span>
          </button>
          <button
            class="btn btn-light btn-outline ms-2"
            @click="toggleControlInstructionsModal"
            data-bs-toggle="tooltip"
            data-bs-placement="left"
            title="View Instructions"
          >
            <i class="bi bi-question-circle"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from "@/data/config";
export default {
  name: "Header",
  data() {
    return {
      course: config.meta.course,
      title: config.meta.title,
      shortTitle: config.meta.shortTitle
    };
  },
  computed: {
    ...mapGetters(["showDataTable"]),
    isOnActivityView() {
      return this.$route.name === "Activity";
    }
  },
  methods: {
    ...mapActions([
      "toggleDataTable",
      "toggleSidebar",
      "toggleControlInstructionsModal"
    ])
  }
};
</script>

<style scoped>
button {
  /* do not zoom on button double-tap on mobile */
  touch-action: manipulation;
}
</style>
